import { userPaths } from "api/apiPaths";
import client from "api/client";
import { BaseApiResponseModel } from "api/model/BaseApiResponseModel";
import { RolesRequestModel } from "../roles/model/RolesRequestModel";
import { RolesResponseModel } from "../roles/model/RolesResponseModel";
import { UsersRequestModel } from "./model/UsersRequestModel";
import { UsersResponseModel } from "./model/UsersResponseModel";
import { ChangePasswordRequestModel } from "./model/actions/ChangePasswordRequestModel";
import { CreateUserRequestModel } from "./model/actions/CreateUserRequestModel";
import { UpdateUserRequestModel } from "./model/actions/UpdateUserRequestModel";
import { UserDetailResponseModel } from "./model/detail/UserDetailResponseModel";
import { UserFeatureResponseModel } from "./model/feature/UserFeatureResponseModel";

export interface IUsersRepository {
  getList(
    params: UsersRequestModel
  ): Promise<BaseApiResponseModel<UsersResponseModel[]>>;
  getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<UserDetailResponseModel>>;
  getFeature(): Promise<BaseApiResponseModel<UserFeatureResponseModel[]>>;
  createUser(
    body: CreateUserRequestModel
  ): Promise<BaseApiResponseModel<UserDetailResponseModel>>;
  updateUser(
    body: UpdateUserRequestModel
  ): Promise<BaseApiResponseModel<UpdateUserRequestModel>>;
  getRole(
    params: RolesRequestModel
  ): Promise<BaseApiResponseModel<RolesResponseModel[]>>;
  changePassword(
    body: ChangePasswordRequestModel
  ): Promise<BaseApiResponseModel<any>>;
  deleteUser(params: {
    code: string;
  }): Promise<BaseApiResponseModel<UserDetailResponseModel>>;
}

class UsersImpl implements IUsersRepository {
  async getList(
    params: UsersRequestModel
  ): Promise<BaseApiResponseModel<UsersResponseModel[]>> {
    return await client?.get(userPaths?.LIST, params);
  }

  async getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<UserDetailResponseModel>> {
    return await client?.get(userPaths?.DETAIL, params);
  }

  async getFeature(): Promise<
    BaseApiResponseModel<UserFeatureResponseModel[]>
  > {
    return await client?.get(userPaths?.FEATURE);
  }

  async createUser(
    body: CreateUserRequestModel
  ): Promise<BaseApiResponseModel<UserDetailResponseModel>> {
    return await client?.post(userPaths?.CREATE, body);
  }

  async updateUser(
    body: UpdateUserRequestModel
  ): Promise<BaseApiResponseModel<UpdateUserRequestModel>> {
    return await client?.put(userPaths?.UPDATE, body);
  }

  async getRole(
    params: RolesRequestModel
  ): Promise<BaseApiResponseModel<RolesResponseModel[]>> {
    return await client?.get(userPaths?.ROLE, params);
  }

  async changePassword(
    body: ChangePasswordRequestModel
  ): Promise<BaseApiResponseModel<any>> {
    return await client?.put(userPaths?.CHANGE_PASSWORD, body);
  }

  async deleteUser(params: {
    code: string;
  }): Promise<BaseApiResponseModel<UserDetailResponseModel>> {
    return await client?.delete(userPaths?.DELETE, params);
  }
}

export const defaultUserRepository = new UsersImpl();
